import React, {} from "react"

export default function CloseSubscribePopupInfo(no_popup_open){
    this.setState(
        {
            subscription_popup_info_open: false,

        }
    )
    if (no_popup_open){
      this.setState(
         {
            subscribe_popup_open: false,
         }
      )
   } else {
      this.setState(
         {
            subscribe_popup_open: false,
         }
      )
   }

}
